import create from 'zustand';
import { User } from '../../types/auth.types';

interface UseLocalUserType {
  user: User | null;
  setUser: (newUser: User | null) => void;
  removeUser: () => void;
}

const useLocalUser = create<UseLocalUserType>()((set) => ({
  user: null,
  setUser: (newUser: User | null) => set(() => ({ user: newUser })),
  removeUser: () => set({ user: null }),
}));

export default useLocalUser;
